module.exports = __webpack_public_path__ + "media/1_15.dd0cde8d.wav";